/**
 * PeerJS signaling dial budget.
 * An already-open socket heartbeat is cheap. A new peer.connect() is an OFFER
 * the signaling server must relay, so repeat dials and directory sweeps are capped.
 */
export const SIGNALING_DIAL_COOLDOWN_MS = 8_000;
export const SIGNALING_DIAL_BURST = 8;
export const SIGNALING_DIAL_WINDOW_MS = 10_000;

export function createSignalingDialGate({
  cooldownMs = SIGNALING_DIAL_COOLDOWN_MS,
  burst = SIGNALING_DIAL_BURST,
  windowMs = SIGNALING_DIAL_WINDOW_MS
} = {}) {
  const dialedAt = new Map();
  const attempts = [];
  const priority = new Set();

  return {
    prioritize(peerId) {
      if (!peerId) {
        return;
      }
      dialedAt.delete(peerId);
      priority.add(peerId);
    },
    allow(peerId, now = Date.now()) {
      if (!peerId) {
        return false;
      }
      if (priority.has(peerId)) {
        priority.delete(peerId);
        dialedAt.set(peerId, now);
        return true;
      }
      const last = dialedAt.get(peerId);
      if (last != null && now - last < cooldownMs) {
        return false;
      }
      while (attempts.length && now - attempts[0] >= windowMs) {
        attempts.shift();
      }
      if (attempts.length >= burst) {
        return false;
      }
      dialedAt.set(peerId, now);
      attempts.push(now);
      return true;
    }
  };
}
